export default {
  key: "category",
  basePath: "/category",
  exclude: false,
};
